export default __webpack_public_path__ + "images/e3951b939d04752f2d1954ce13b738b6-finance.jpg";